import {
  Cpu,
  FileVideo,
  Flame,
  Image,
  Layers,
  Monitor,
  Play,
  Smile,
  Sparkles,
  Timer,
} from 'lucide-react';
import React from 'react';

/** Tooltip style constants as requested */
export const TOOLTIP_CLASSES =
  'rounded-xl border-none bg-[#e2e3e2] px-6 py-3 text-[12px] font-bold text-[#2e2e2e] shadow-xl';

interface IconProps {
  size?: number;
  className?: string;
}

// Resolution Icons
export const Resolution480Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask480">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="8"
        fontWeight="bold"
        fill="black"
      >
        480p
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask480)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="6.5"
      fontWeight="900"
      fill="currentColor"
    >
      SD
    </text>
  </svg>
);

export const Resolution720Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask720">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="8"
        fontWeight="bold"
        fill="black"
      >
        720p
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask720)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="7"
      fontWeight="900"
      fill="currentColor"
    >
      HD
    </text>
  </svg>
);

export const Resolution1080Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask1080">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="7.5"
        fontWeight="bold"
        fill="black"
      >
        1080p
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask1080)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="7"
      fontWeight="900"
      fill="currentColor"
    >
      FHD
    </text>
  </svg>
);

export const EnhanceIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3l1.8 5.6a.4.4 0 00.3.3l5.6 1.8a.4.4 0 010 .8L14.1 13.3a.4.4 0 00-.3.3l-1.8 5.6a.4.4 0 01-.8 0L9.4 13.6a.4.4 0 00-.3-.3l-5.6-1.8a.4.4 0 010-.8l5.6-1.8a.4.4 0 00.3-.3l1.8-5.6a.4.4 0 01.8 0z"
      fill="currentColor"
    />
    <path
      d="M19 16l.6 1.9a.2.2 0 00.1.1l1.9.6a.2.2 0 010 .4L19.7 19.6a.2.2 0 00-.1.1l-.6 1.9a.2.2 0 01-.4 0L18 19.7a.2.2 0 00-.1-.1l-1.9-.6a.2.2 0 010-.4l1.9-.6a.2.2 0 00.1-.1l.6-1.9a.2.2 0 01.4 0z"
      fill="currentColor"
    />
  </svg>
);

export const Resolution1KIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask1k">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="9"
        fontWeight="bold"
        fill="black"
      >
        1K
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask1k)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="7"
      fontWeight="900"
      fill="currentColor"
    >
      HD
    </text>
  </svg>
);

export const Resolution2KIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask2k">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="9"
        fontWeight="bold"
        fill="black"
      >
        2K
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask2k)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="7"
      fontWeight="900"
      fill="currentColor"
    >
      QHD
    </text>
  </svg>
);

export const Resolution4KIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <mask id="mask4k">
      <rect x="1" y="2" width="22" height="20" rx="2" fill="white" />
      <text
        x="12"
        y="9.5"
        textAnchor="middle"
        fontFamily="Arial"
        fontSize="9"
        fontWeight="bold"
        fill="black"
      >
        4K
      </text>
    </mask>
    <rect x="1" y="2" width="22" height="10" fill="currentColor" mask="url(#mask4k)" />
    <rect x="1" y="12" width="22" height="10" stroke="currentColor" strokeWidth="1.5" rx="2" />
    <text
      x="12"
      y="19.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="7"
      fontWeight="900"
      fill="currentColor"
    >
      UHD
    </text>
  </svg>
);

// Duration Icons
export const Duration5Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3v5h5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="12"
      y="15.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="9"
      fontWeight="900"
      fill="currentColor"
    >
      5
    </text>
  </svg>
);

export const Duration6Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3v5h5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="12"
      y="15.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="9"
      fontWeight="900"
      fill="currentColor"
    >
      6
    </text>
  </svg>
);

export const Duration10Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3v5h5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="12"
      y="15.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="8"
      fontWeight="900"
      fill="currentColor"
    >
      10
    </text>
  </svg>
);

export const Duration15Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3v5h5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="12"
      y="15.5"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="8"
      fontWeight="900"
      fill="currentColor"
    >
      15
    </text>
  </svg>
);

// Format Icons
export const JPGIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <text
      x="12"
      y="15"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="8"
      fontWeight="900"
      fill="currentColor"
    >
      JPG
    </text>
  </svg>
);

export const PNGIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <text
      x="12"
      y="15"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="8"
      fontWeight="900"
      fill="currentColor"
    >
      PNG
    </text>
  </svg>
);

// Variations Icons
export const Var1Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="5" y="5" width="14" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <text x="12" y="15.5" textAnchor="middle" fontSize="9" fill="currentColor" fontWeight="900">
      x1
    </text>
  </svg>
);

export const Var2Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="4" y="5" width="10" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
    <mask id="maskVar2">
      <rect x="0" y="0" width="24" height="24" fill="white" />
      <rect x="4" y="5" width="10" height="10" rx="1.5" fill="black" />
    </mask>
    <rect
      x="10"
      y="9"
      width="10"
      height="10"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
      mask="url(#maskVar2)"
    />
    <text x="9" y="13.5" textAnchor="middle" fontSize="8" fill="currentColor" fontWeight="900">
      2
    </text>
  </svg>
);

export const Var3Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    {/* Bottom two boxes */}
    <rect x="3" y="11" width="8" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13" y="11" width="8" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    {/* Top middle box */}
    <rect x="8" y="3" width="8" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" />
    <text x="12" y="9.5" textAnchor="middle" fontSize="7" fill="currentColor" fontWeight="900">
      3
    </text>
  </svg>
);

export const Var4Icon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="3" y="4" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13" y="4" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="3" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
    <rect x="13" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

// Mode Icons
export const ModeNormalIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <line x1="4" y1="12" x2="20" y2="12" stroke="currentColor" strokeWidth="1.5" />
    <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" />
  </svg>
);

export const ModeFunIcon = ({ size = 24 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <text
      x="12"
      y="12"
      textAnchor="middle"
      fontFamily="Arial"
      fontSize="9"
      fontWeight="900"
      fill="currentColor"
    >
      FUN
    </text>
    <path
      d="M8 15.5c1.5 1.5 6.5 1.5 8 0"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ModeSpicyIcon = ({ size = 24 }: IconProps) => <Flame size={size} strokeWidth={1.5} />;
